export default function OutletCard({ outlet, dark = false }) {
  const shell = dark
    ? 'bg-[#2B1B12] text-[#FDFBF7] border border-[#4a3526]'
    : 'bg-white text-[#1A110B] border border-[#E2D3BE]';
  return (
    <article
      data-testid={`outlet-card-${outlet.id}`}
      className={`${shell} rounded-lg p-6 flex flex-col gap-4 shadow-sm hover:shadow-md transition-shadow`}
    >
      <div>
        <span className="font-pricemono text-[11px] tracking-widest uppercase text-[#D9822B]">
          {outlet.badge}
        </span>
        <h3 className="font-display text-2xl font-semibold mt-1">{outlet.name}</h3>
      </div>
      <address className={`not-italic text-sm leading-relaxed ${dark ? 'text-[#E8DCC9]' : 'text-[#6E6259]'}`}>
        {outlet.address}
      </address>
      {outlet.hours ? (
        <p className={`text-sm ${dark ? 'text-[#E8DCC9]' : 'text-[#6E6259]'}`}>
          <span className="font-medium">Jam buka:</span> {outlet.hours}
        </p>
      ) : (
        <p className={`text-sm ${dark ? 'text-[#E8DCC9]' : 'text-[#6E6259]'}`}>
          Jam operasional mengikuti outlet — cek Instagram resmi untuk info terkini.
        </p>
      )}
      <div className="mt-auto flex flex-wrap gap-3 pt-2">
        <a
          data-testid={`outlet-directions-${outlet.id}`}
          href={outlet.maps}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#C84B27] text-[#FDFBF7] text-sm font-semibold px-4 py-2.5 rounded-md hover:bg-[#a93d1f] transition-colors active:scale-95"
        >
          Petunjuk Arah
        </a>
        <a
          data-testid={`outlet-instagram-${outlet.id}`}
          href={outlet.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className={`inline-flex items-center gap-2 text-sm font-semibold px-4 py-2.5 rounded-md border transition-colors active:scale-95 ${
            dark
              ? 'border-[#4a3526] text-[#FDFBF7] hover:bg-[#3a281c]'
              : 'border-[#E2D3BE] text-[#2B1B12] hover:bg-[#F5EFE6]'
          }`}
        >
          {outlet.igHandle}
        </a>
      </div>
    </article>
  );
}
